<template>
  <section class="hero-carousel">
    <div v-if="slides.length > 0" class="hero-carousel__slider">
      <div class="swiper hero-carousel-slider">
        <div class="swiper-wrapper">
          <div v-for="(slide, i) in slides" class="swiper-slide">
            <hero-carousel-slide :slide="slide" :key="i" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="slides.length > 1" class="hero-carousel__control">
      <span class="hero-carousel__control-buttons">
        <hero-carousel-play-pause  :is-pause="playPauseState" @click="togglePlayPause" />
        <div class="hero-carousel-pagination"></div>
      </span>
    </div>
  </section>
</template>

<script lang="ts">
  import { onMounted, ref, Ref, watch } from "vue";
  import { IHeroCarouselProps } from "../helpers/HeroCarouselTypes";
  import Swiper, { Pagination, Autoplay } from 'swiper';

  export default {
    name: 'HeroCarousel',
    props: {
      slides: {
        type: Array,
        required: true,
      },
    },
    setup(props: IHeroCarouselProps) {
      let slider: Ref<Swiper>;
      const playPauseState = ref(true);

      onMounted(() => {
        Swiper.use([Pagination, Autoplay]);

        slider = ref(new Swiper('.hero-carousel-slider', {
          slidesPerView: 1,
          centeredSlides: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          pagination: {
            el: ".hero-carousel-pagination",
            clickable: true,
          },
        }));

        slider.value.init()
      })

      watch(playPauseState, (newState: boolean) => {
        if (newState) {
          slider.value.autoplay.start()
        } else {
          slider.value.autoplay.stop()
        }
      });

      const togglePlayPause = () => {
        playPauseState.value = !playPauseState.value;
      }

      return {
        togglePlayPause,
        playPauseState
      }
    }
  };
</script>
